import { Component } from '@angular/core';
import { ComingSoonPage } from '../../../../../shared/ui/coming-soon-page/coming-soon-page';

@Component({
  selector: 'app-create-offer',
  imports: [ComingSoonPage],
  templateUrl: './create-offer.html',
  styleUrl: './create-offer.scss',
})
export class CreateOffer {}
